import { SERVICE_HAPPY_ORDER_UPDATE } from '../mutationTypes';

const initState = {
  detail: {},
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [SERVICE_HAPPY_ORDER_UPDATE](states, newValue = initState.detail) {
    const detail = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { detail });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
